const legalContent = {
  villkor: {
    title: "Allmänna villkor",
    updated: "1 maj 2026",
    sections: [
      { h: "1. Tjänsten", p: "Byggro AB tillhandahåller en molnbaserad plattform för hantering av affärer, offerter och projekt riktad till hantverkare och byggföretag. Tjänsten erbjuds som en prenumeration enligt valt paket." },
      { h: "2. Avtal och bindningstid", p: "Avtalet gäller från det att du skapar ett konto. Prenumerationen löper månadsvis utan bindningstid. Du kan säga upp tjänsten när som helst — uppsägningen träder i kraft vid nästa faktureringsperiod." },
      { h: "3. Priser och betalning", p: "Aktuella priser framgår på byggro.com. Priser anges exklusive moms. Betalning sker månadsvis via faktura eller kortbetalning. Byggro AB förbehåller sig rätten att justera priser med 30 dagars förvarning." },
      { h: "4. Användarens ansvar", p: "Du ansvarar för att uppgifterna i tjänsten är korrekta och att inloggningsuppgifter hanteras säkert. Du får inte använda tjänsten i strid med svensk lag eller på sätt som kan skada Byggro AB eller andra användare." },
      { h: "5. Tillgänglighet och support", p: "Byggro AB strävar efter hög tillgänglighet men garanterar inte avbrottsfri drift. Planerade underhåll aviseras i förväg. Support ges via e-post under vardagar." },
      { h: "6. Immateriella rättigheter", p: "Byggro AB äger alla rättigheter till plattformen, inklusive programvara, design och varumärken. Du behåller alla rättigheter till den data du lägger in i tjänsten." },
      { h: "7. Ansvarsbegränsning", p: "Byggro AB ansvarar inte för indirekta skador, utebliven vinst eller förlust av data utöver vad som orsakats av grov vårdslöshet. Byggro ABs totala ansvar är begränsat till de avgifter du betalat de senaste 12 månaderna." },
      { h: "8. Uppsägning och data", p: "Vid uppsägning kan du exportera din data i 30 dagar. Därefter raderas all data, inklusive säkerhetskopior, inom 90 dagar." },
      { h: "9. Ändringar av villkor", p: "Byggro AB kan uppdatera dessa villkor. Väsentliga ändringar meddelas via e-post minst 30 dagar i förväg. Fortsatt användning efter ändring innebär att du godkänner de nya villkoren." },
      { h: "10. Tillämplig lag", p: "Svensk lag tillämpas. Tvister avgörs av svensk allmän domstol." },
    ],
  },
  integritet: {
    title: "Integritetspolicy",
    updated: "1 maj 2026",
    sections: [
      { h: "1. Personuppgiftsansvarig", p: "Byggro AB är personuppgiftsansvarig för behandlingen av dina personuppgifter. Kontakta oss på byggro@northcollective.se vid frågor." },
      { h: "2. Vilka uppgifter vi samlar in", p: "Vi samlar in namn, e-postadress, företagsnamn och telefonnummer vid registrering. Genom användning av tjänsten samlar vi in projektdata, offerter och aktivitetsloggar som du själv lägger in." },
      { h: "3. Varför vi behandlar dina uppgifter", p: "Vi behandlar personuppgifter för att tillhandahålla tjänsten, hantera ditt konto, skicka viktig information om tjänsten och förbättra vår produkt. Rättslig grund är fullgörande av avtal samt berättigat intresse." },
      { h: "4. Delning med tredje part", p: "Vi delar inte dina personuppgifter med tredje part i marknadsföringssyfte. Underleverantörer som behandlar data å våra vägnar är bundna av personuppgiftsbiträdesavtal. All data lagras inom EU." },
      { h: "5. Lagring och radering", p: "Dina uppgifter lagras så länge du har ett aktivt konto. Vid uppsägning raderas personuppgifter och all projektdata inom 90 dagar. Data som krävs enligt bokföringslagen sparas i 7 år." },
      { h: "6. Dina rättigheter", p: "Du har rätt att begära tillgång till, rättelse av och radering av dina personuppgifter. Du kan även begära dataportabilitet och invända mot behandling. Kontakta oss på byggro@northcollective.se." },
      { h: "7. Cookies", p: "Vi använder nödvändiga cookies för att tjänsten ska fungera samt analyticscookies för att förstå hur tjänsten används. Du kan hantera dina cookie-inställningar i webbläsaren." },
      { h: "8. Säkerhet", p: "Vi skyddar dina uppgifter med kryptering vid överföring och lagring, åtkomstkontroller och regelbundna säkerhetskontroller. All drift sker hos svenska och europeiska leverantörer." },
      { h: "9. Ändringar", p: "Vi kan uppdatera denna policy. Väsentliga ändringar meddelas via e-post. Senast uppdaterad anges överst i dokumentet." },
    ],
  },
};

const LegalModal = () => {
  const [page, setPage] = React.useState(null);

  React.useEffect(() => {
    const handler = (e) => setPage(e.detail);
    window.addEventListener('open-legal', handler);
    return () => window.removeEventListener('open-legal', handler);
  }, []);

  if (!page || !legalContent[page]) return null;

  const content = legalContent[page];

  return (
    <div className="legal-overlay" onClick={() => setPage(null)}>
      <div className="legal-modal card" onClick={(e) => e.stopPropagation()}>
        <div className="legal-header">
          <h2 style={{fontSize:24}}>{content.title}</h2>
          <button className="legal-close" onClick={() => setPage(null)}>✕</button>
        </div>
        <div className="legal-updated" style={{fontSize:13, color:'var(--ink-3)', marginBottom:24}}>
          Senast uppdaterad {content.updated}
        </div>
        <div className="legal-body">
          {content.sections.map((s, i) => (
            <div key={i} style={{marginBottom:24}}>
              <h3 style={{fontSize:15, marginBottom:8}}>{s.h}</h3>
              <p style={{fontSize:14, lineHeight:1.6, color:'var(--ink-2)'}}>{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Object.assign(window, { LegalModal });
